import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-terms',
  styleUrl: './terms.scss',
  templateUrl: './terms.html',
})
export class Terms {
}
